import { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

export const MobileCta = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const on = () => {
      const f = document.getElementById("pool-check")?.getBoundingClientRect();
      const inFunnel = f ? f.top < window.innerHeight && f.bottom > 0 : false;
      setShow(window.scrollY > window.innerHeight * 0.8 && !inFunnel);
    };
    window.addEventListener("scroll", on, { passive: true });
    return () => window.removeEventListener("scroll", on);
  }, []);
  return (
    <div className={`fixed inset-x-4 bottom-4 z-40 lg:hidden transition-[transform,opacity] duration-500 ${show ? "translate-y-0 opacity-100" : "translate-y-24 opacity-0 pointer-events-none"}`}>
      <button data-testid="mobile-sticky-cta" onClick={() => scrollToId("pool-check")} className="btn-primary w-full justify-center shadow-2xl">
        Kostenlosen Pool-Check starten <ArrowRight className="h-4 w-4" />
      </button>
    </div>
  );
};
